import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Silence noisy console output by default in the browser, leaving only errors and warnings.
// You can re-enable verbose logs by setting localStorage.DEBUG_CONSOLE = 'true'
// or by setting window.__DEBUG_CONSOLE__ = true at runtime, or by building with REACT_APP_VERBOSE_CONSOLE=true
(function configureConsoleFiltering() {
  try {
    const verboseFromEnv = String(process.env.REACT_APP_VERBOSE_CONSOLE || '').toLowerCase() === 'true';
    const debugFlagFromStorage = (typeof window !== 'undefined') && window.localStorage && window.localStorage.getItem('DEBUG_CONSOLE') === 'true';
    const debugFlagFromWindow = (typeof window !== 'undefined') && window.__DEBUG_CONSOLE__ === true;
    const keepVerbose = verboseFromEnv || debugFlagFromStorage || debugFlagFromWindow;
    if (!keepVerbose) {
      const noop = () => {};
      // Keep console.error and console.warn; silence log/info/debug by default
      try { console.log = noop; } catch (_) { void 0; }
      try { console.info = noop; } catch (_) { void 0; }
      try { console.debug = noop; } catch (_) { void 0; }
    }
  } catch (_e) {
    void 0;
  }
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
